import React, { useState } from "react";
import { Col, Popover, PopoverBody, PopoverHeader } from "reactstrap";

const formatNumber = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const number = Number(value);
  return Number.isNaN(number) ? value : number.toLocaleString();
};

const CurrentStockPopover = ({ index, totalStock, variants = [] }) => {
  const [popoverOpen, setPopoverOpen] = useState(false);
  const targetId = `ai-current-stock-trigger-${index}`;
  const skuVariants = Array.isArray(variants) ? variants : [];
  const variantStock = skuVariants.reduce(
    (total, variant) => total + (Number(variant.end_quantity) || 0),
    0
  );
  const currentStock = totalStock ?? variantStock;

  return (
    <Col sm={6}>
      <div
        id={targetId}
        className="d-flex align-items-center justify-content-between py-3 border-bottom h-100"
        role="button"
        tabIndex={0}
        onClick={() => setPopoverOpen((open) => !open)}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            setPopoverOpen((open) => !open);
          }
        }}
        style={{ cursor: "pointer" }}
        title="Click to view the SKU-wise stock breakdown"
      >
        <div className="text-muted small mr-3">
          Current Stock <i className="fa fa-info-circle ml-1" />
        </div>
        <div className="font-weight-bold text-right">{formatNumber(currentStock)}</div>
      </div>

      <Popover
        placement="auto"
        target={targetId}
        isOpen={popoverOpen}
        toggle={() => setPopoverOpen((open) => !open)}
        style={{ minWidth: "300px" }}
      >
        <PopoverHeader>
          <div className="d-flex align-items-center justify-content-between" style={{ width: "100%" }}>
            <span>SKU-wise Stock Breakdown</span>
            <button
              type="button"
              className="close ml-3"
              aria-label="Close SKU-wise stock breakdown"
              onClick={() => setPopoverOpen(false)}
              style={{ fontSize: "20px", lineHeight: 1 }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </PopoverHeader>
        <PopoverBody style={{ maxHeight: "45vh", overflowY: "auto" }}>
          {skuVariants.length === 0 ? (
            <div className="text-muted">No SKU stock breakdown available.</div>
          ) : skuVariants.map((variant, variantIndex) => (
            <div
              key={variant.sku || variantIndex}
              className="d-flex justify-content-between py-1"
              style={variantIndex > 0 ? { borderTop: "1px solid #dee2e6" } : undefined}
            >
              <span className="text-muted mr-3">{variant.sku || `SKU ${variantIndex + 1}`}</span>
              <span className="font-weight-bold">{formatNumber(variant.end_quantity)}</span>
            </div>
          ))}
        </PopoverBody>
      </Popover>
    </Col>
  );
};

export default CurrentStockPopover;
